import './image.scss';
import { IImage } from 'types/interfaces';

export default function Image(props: IImage) {
  return (
    <img
      id={props.id}
      className={`${props.className ? props.className : 'image-default'}`}
      src={props.src}
      alt={props.alt ? props.alt : 'image-default'}
      loading={props.loading}
      style={props.style}
    />
  );
}
